module.exports = __webpack_public_path__ + "img/fi-rr-rotate-right.298182fe.svg";